import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const OwnerCard = ({ owner, onSelect, isSelected }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'نشط':
        return 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400';
      case 'معلق':
        return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400';
      case 'غير نشط':
        return 'bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-400';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div
      onClick={() => onSelect(owner)}
      className={`p-4 rounded-lg border transition-all duration-250 cursor-pointer hover:shadow-warm ${
        isSelected
          ? 'border-primary bg-primary/5' :'border-border bg-card hover:border-primary/50'
      }`}
    >
      <div className="flex items-start gap-3">
        <div className="relative flex-shrink-0">
          <Image
            src={owner?.avatar}
            alt={owner?.avatarAlt}
            className="w-12 h-12 md:w-14 md:h-14 rounded-lg object-cover"
          />
          {owner?.verified && (
            <div className="absolute -bottom-1 -left-1 w-5 h-5 bg-success rounded-full flex items-center justify-center border-2 border-card">
              <Icon name="Check" size={12} color="#FFFFFF" />
            </div>
          )}
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-1">
            <h3 className="font-heading font-semibold text-foreground text-sm md:text-base line-clamp-1">
              {owner?.name}
            </h3>
            <span
              className={`px-2 py-0.5 rounded-full text-xs font-caption whitespace-nowrap ${getStatusColor(
                owner?.status
              )}`}
            >
              {owner?.status}
            </span>
          </div>

          <div className="space-y-1 mb-2">
            <div className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
              <Icon name="Building2" size={14} />
              <span className="font-data">{owner?.propertyCount} عقار</span>
            </div>
            <div className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
              <Icon name="Phone" size={14} />
              <span className="font-data" dir="ltr">
                {owner?.phone}
              </span>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="xs"
              iconName="MessageSquare"
              iconSize={14}
              onClick={(e) => {
                e?.stopPropagation();
                console.log('Open WhatsApp for', owner?.name);
              }}
            >
              واتساب
            </Button>
            <Button
              variant="ghost"
              size="xs"
              iconName="Phone"
              iconSize={14}
              onClick={(e) => {
                e?.stopPropagation();
                console.log('Call', owner?.name);
              }}
            >
              اتصال
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OwnerCard;